import axios from "axios";

export const giftcardService = {
  checkGiftCardbalance,
  checkBalance,
  useGiftCard,
  setSessionOrders,
  handleGiftCardPayment,
};

// const apiBaseURL = `${apiUrl}/users`;
// const apiBaseURL = "http://dev.siapi.com/public/";
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const siteId = process.env.REACT_APP_SITE_ID;
const serverId = process.env.REACT_APP_SERVER_ID;

async function checkGiftCardbalance(params) {
  let formData = new URLSearchParams();

  formData.append("serverId", serverId);
  formData.append("siteId", siteId);
  formData.append("cardNumber", params.giftcard_number);
  formData.append("giftcard_cvc", params.giftcard_cvc);
  formData.append("orderpayment_amount", 10);

  return await axios.post(`${apiBaseURL}giftcards/checkbalance`, formData);
}

async function checkBalance(cardNumber) {
  try {
    const response = await axios.get(
      `${apiBaseURL}/giftcards/checkbalance/${serverId}/${siteId}/${cardNumber}`
    );

    // Transform the response to match the expected format
    if (response.data && response.data.success && response.data.data) {
      return {
        success: true,
        balance: parseFloat(response.data.data.balance_amount) || 0,
        giftCardInfo: response.data.data,
      };
    } else {
      return {
        success: false,
        balance: 0,
        message: response.data?.message || "Gift card not found",
      };
    }
  } catch (error) {
    console.error("Gift card balance check error:", error);
    return {
      success: false,
      balance: 0,
    };
  }
}

async function useGiftCard(cardNumber, amount) {
  try {
    const response = await axios.get(
      `${apiBaseURL}/giftcards/use/${serverId}/${siteId}/${cardNumber}/${amount}`
    );

    // Return the response data
    if (response.data && response.data.success) {
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        message: response.data?.message || "Failed to use gift card",
      };
    }
  } catch (error) {
    console.error("Gift card use error:", error);
    return {
      success: false,
      message: "An error occurred while processing the gift card",
    };
  }
}

async function setSessionOrders(params) {
  let formData = new URLSearchParams();
  let cartItems = params.cartItems;
  let customerData = params.selectedAddress;
  let paymentsData = params.payments;

  Object.keys(cartItems).forEach((key) => {
    // for (var items in cartItems[key]) {
    //   if (items == "modifiers") {
    //     let mods = cartItems[key][items];
    //     for (var mod in mods) {
    //       Object.keys(cartItems[key][items][mod]).forEach((idx, modVal) => {
    //         formData.append(
    //           `cartItems[${key}][${items}][${mod}][${idx}]`,
    //           mods[mod][idx]
    //         );
    //       });
    //     }
    //   } else {
    //     formData.append(`cartItems[${key}][${items}]`, cartItems[key][items]);
    //   }
    // }
  });

  Object.keys(customerData).forEach((k) => {
    formData.append(`selectedAddress[${k}]`, customerData[k]);
  });

  formData.append("pid", params.pid);
  formData.append("tips", params.tips);
  formData.append("promoCode", params.promoCode);
  formData.append("total", params.total);
  formData.append("subTotal", params.subTotal);
  formData.append("instructions", params.instructions);
  formData.append("orderProcessingType", params.orderProcessingType);
  formData.append("orderProcessingDate", params.orderProcessingDate);
  formData.append("order_id", params.orderId);

  Object.keys(paymentsData).forEach((key) => {
    // for (var items in paymentsData[key]) {
    //   formData.append(`payments[${key}][${items}]`, paymentsData[key][items]);
    // }
  });

  return await axios.post(
    `${apiBaseURL}giftcards/${siteId}/saveOrders`,
    formData
  );
}

async function handleGiftCardPayment(params) {
  let formData = new URLSearchParams();
  formData.append("order_id", params.order_id);
  formData.append("user_id", params.user_id);
  formData.append("data", params.data);

  return await axios.post(
    `${apiBaseURL}giftcards/${siteId}/paymentAndSendtoEconnect`,
    formData
  );
}
